module.exports = __webpack_public_path__ + "images/e38199b9122bccb0794235a6eb818aa3.png";